import { Typography, Table, TableBody, TableRow, TableCell, Paper } from '@mui/material';
import colors from 'assets/theme/base/colors';

const MoreClassficationDetails = ({ classificationPerformance, targetDrift }: any) => {
	return (
		<Paper elevation={8} className="width-65"
		sx={{
			"&.MuiPaper-root": {
				padding: '16px !important',
				backgroundColor: `${colors.backgroundLight.dark} !important`,
			},
		}}
		>
			<Typography variant="subHeader" component="h6" mb={2}>
				More Details
			</Typography>
			<Table  className="performance-overview-table">
				<TableBody>
					<TableRow>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Accuracy</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">
							{classificationPerformance?.Accuracy?.toFixed(6)}
						</Typography>
						</TableCell>
						<TableCell
						className="emptyCell"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						/>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">F1 Score</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">
							{classificationPerformance?.['F1-Score']?.toFixed(6)}
						</Typography>
						</TableCell>
					</TableRow>

					<TableRow>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Precision</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">
							{classificationPerformance?.Precision?.toFixed(6)}
						</Typography>
						</TableCell>
						<TableCell
						className="emptyCell"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						/>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Classes in Inference</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">
							{targetDrift?.current_distribution?.x?.length}
						</Typography>
						</TableCell>
					</TableRow>

					<TableRow>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Recall</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">
							{classificationPerformance?.Recall?.toFixed(6)}
						</Typography>
						</TableCell>
						<TableCell
						className="emptyCell"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						/>
						<TableCell
						className="attrTitle"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">Classes in Reference</Typography>
						</TableCell>
						<TableCell
						className="attrValue"
						sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}
						>
						<Typography variant="bodyText">
							{targetDrift?.reference_distribution?.x?.length}
						</Typography>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</Paper>
	);
};

export default MoreClassficationDetails;
